define('pages/news/news_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/user/user_model',

  'modules/news/news_view',

  'text!./news_page_template.html'

], function (Backbone, $, _, user, NewsView, news_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (options) {

      this.subViews = [];

      this.news = new NewsView();
      this.subViews.push(this.news);

      this.render();

      this.renderSubView();
    },

    template: _.template(news_page_template),
    subViews: [],

    render: function () {
      this.$el.html(this.template({can_create_news: user.capability('news', 'can_create')}));
      return this;
    },

    renderSubView: function () {
      this.$('.news-page-content').html(this.news.$el);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

